import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "opModal noHeight text-center" }
const _hoisted_2 = { class: "midTitle" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "lowTitle" }
const _hoisted_6 = { class: "mt-2 btn btn-secondary" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Seleziona la location",
            text: "Seleziona la location"
          })
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedVillage) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.villages, (item, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.identifier,
              value: item
            }, _toDisplayString(item.title.values[_ctx.$store.state.selectedLanguage]), 9, _hoisted_4))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedVillage]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_localized_text, {
        localizedKey: "oppure",
        text: "oppure"
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Dai l'accesso alla tua posizione per trovarlo in automatico",
          text: "Dai l'accesso alla tua posizione per trovarlo in automatico"
        })
      ]),
      _createElementVNode("button", _hoisted_6, [
        _createVNode(_component_localized_text, {
          localizedKey: "Leggi posizione",
          text: "Leggi posizione"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          disabled: !_ctx.selectedVillage,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Conferma",
            text: "Conferma"
          })
        ], 8, _hoisted_8)
      ]),
      (_ctx.cancelCallback)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Annulla",
                text: "Annulla"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}